// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-item {
  margin-top: 0.5rem;
  border-bottom: 1px solid whitesmoke;
  border-radius: 4px;
  padding-bottom: 0.5rem;
}

.notes-area {
  font-size: 0.9rem;
  padding: 0.4rem;
  min-height: 10rem;
  margin-right: 0.3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/filming-location/filming-form/filming-form.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACF","sourcesContent":[".location-item {\n  margin-top: 0.5rem;\n  border-bottom: 1px solid whitesmoke;\n  border-radius: 4px;\n  padding-bottom: 0.5rem;\n}\n\n.notes-area {\n  font-size: 0.9rem;\n  padding: 0.4rem;\n  min-height: 10rem;\n  margin-right: 0.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
